import {
  SkeletonBox,
  SkeletonContainer,
  SkeletonLabel,
} from "@/components/ui/skeleton";

/** Loading placeholder for the edit form body while the snippet is fetched. */
export function SnippetEditorSkeleton() {
  return (
    <SkeletonContainer
      className="min-h-0 flex-1 flex-col gap-6 bg-surface-primary px-6 py-6 dark:bg-[#232325]"
      data-testid="snippet-editor-skeleton"
    >
      {/* Name */}
      <div className="flex flex-col gap-2">
        <SkeletonLabel className="h-3.5 w-28" />
        <SkeletonBox className="h-9 w-full rounded-md" />
      </div>

      {/* Visibility */}
      <div className="flex flex-col gap-2">
        <SkeletonLabel className="h-3.5 w-32" />
        <SkeletonLabel className="h-4 w-64" />
        <SkeletonLabel className="h-4 w-44" />
      </div>

      {/* Content (fills remaining height) */}
      <div className="flex min-h-0 flex-1 flex-col gap-2">
        <SkeletonLabel className="h-3.5 w-28" />
        <SkeletonBox className="min-h-0 w-full flex-1 rounded-lg" />
      </div>
    </SkeletonContainer>
  );
}
